import {useEffect,useState} from 'react';
import {HELP_CONTENT} from './helpContent';
export default function EditorDialogs({type,onClose,onImport,onDownload,busy}){
 const [file,setFile]=useState(null),[mode,setMode]=useState('replace'),[samples,setSamples]=useState(true);
 useEffect(()=>{const key=e=>{if(e.key==='Escape'&&!busy)onClose();};window.addEventListener('keydown',key);return()=>window.removeEventListener('keydown',key);},[onClose,busy]);
 return <div className="de-dialog-shade"><div className="de-dialog" role="dialog" aria-modal="true" aria-label={type}>
 <h2>{type==='help'?'How to use':type==='upload'?'Upload Word document':'Download document'}</h2>
 {type==='help'&&HELP_CONTENT.map(([title,text])=><section key={title}><h3>{title}</h3><p>{text}</p></section>)}
 {type==='upload'&&<>
 <input type="file" accept=".docx" disabled={busy} onChange={e=>setFile(e.target.files[0]||null)}/>
 <label><input type="radio" checked={mode==='replace'} onChange={()=>setMode('replace')}/>Replace document (confirmation required)</label>
 <label><input type="radio" checked={mode==='insert'} onChange={()=>setMode('insert')}/>Insert at the saved cursor</label>
 <p>Formatting is adapted to A4. Files above 5 MB prompt a warning; maximum 20 MB.</p>
 <button disabled={!file||busy} onClick={()=>onImport(file,mode)}>{busy?'Importing…':'Import'}</button>
 </>}
 {type==='download'&&<>
 <label><input type="checkbox" checked={samples} onChange={e=>setSamples(e.target.checked)}/>Fill sample values (otherwise keep template tokens)</label>
 <p>PDF uses your browser’s print dialog. Select Save as PDF; background graphics must be enabled.</p>
 <button disabled={busy} onClick={()=>onDownload('pdf',samples)}>PDF / Print</button>
 <button disabled={busy} onClick={()=>onDownload('html',samples)}>HTML</button>
 <button disabled={busy} onClick={()=>onDownload('docx',samples)}>Word (.docx)</button>
 </>}
 <div className="de-actions"><button disabled={busy} onClick={onClose}>Close</button></div>
 </div></div>;
}
